import CallToActionComponent from "@/components/Button";
import { SVGDownload as SVGDownloadComponent } from "@/lib/svg";
import { forwardRef } from "react";
import styled from "styled-components";

// Cast to fix React 17 + @types/react 18 compatibility issue
const CallToAction = CallToActionComponent as any;
const SVGDownload = SVGDownloadComponent as any;

const _Button = forwardRef<HTMLAnchorElement, any>((props, ref) => {
  const CallToActionTyped = CallToAction as any;
  const SVGDownloadTyped = SVGDownload as any;
  return (
    <CallToActionTyped
      as="a"
      ref={ref}
      variant="primaryBoxed"
      {...props}
      icon={<SVGDownloadTyped />}
    />
  );
});

_Button.displayName = "Button";

export const Button = styled(_Button as any)`
  max-width: max-content;
  margin-top: 1.5rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-top: 0;
  }
`;
